import { currentBusinessDate, dateOnlyFromValue } from "./timezone";

export default function getFirstAndLastDateOfCurrentMonth(date) {
  const dateOnly = dateOnlyFromValue(date || currentBusinessDate());
  const [year, month] = dateOnly.split("-").map(Number);
  const lastDay = new Date(Date.UTC(year, month, 0)).getUTCDate();
  const yearText = String(year).padStart(4, "0");
  const monthText = String(month).padStart(2, "0");
  return [
    yearText + "-" + monthText + "-01",
    yearText + "-" + monthText + "-" + String(lastDay).padStart(2, "0"),
  ];
}
